import React from 'react'
import { withModal } from '../provider'
// TODO move ui
// import { Modal } from '@brainstud/schiphol-vtc-ui'

const Layout = props => (
  <Modal {...props} onClose={props.modal.close} style={props.style}>
    {props.children}
  </Modal>
)

export default withModal(Layout)
